<template lang="pug">
.RoutineTopPage
  .content
    .layout
      .container
        .introduction
          .title ルーティーン
          .description
            | キーボードに毎日触って指を感覚を身につけよう。<br>
            | キーボードを使って何かをする前の準備運動や<br>
            | キーボードを全く使わない日の感覚維持に効果的です。
          .total
            | 今までの合計練習日数は
            span {{routineResultDates.length}}
            | 日です。
          .combo(v-if="routineResult.lastDate > yesterday")
            | {{ routineResult.comboCount }}日継続中!
          km-button(
            size="large"
            styleName="primary"
            @click="handleStartButtonClick"
          ).startButton {{ routineResult.lastDate === today ? 'もう一度スタート' : '今日の練習をスタート' }}
        .calendar
          km-result-calendar(:dates="routineResultDates")
      //- .background(ref="backgroundRef")
  km-loading-overlay(
    v-if="assetLoaded === false"
    :queuedAssets="assets"
    :loadedAssets="loadedAssets"
  )
  km-footer(
    title="ルーティーン"
    :challengeResult="challengeResult"
  )

</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import ResultCalendar from '@/components/routine/ResultCalendar'

export default {
  name: 'routine-top-page',
  components: {
    'km-result-calendar': ResultCalendar
  },
  data() {
    return {
      assetLoaded: null,
      assets: [{ type: 'image', path: require('@/assets/bg_challenge.jpg') }],
      today: moment().format('YYYY-MM-DD'),
      yesterday: moment().subtract(1, 'days').format('YYYY-MM-DD')
    }
  },
  computed: {
    ...mapState('User', {
      rank: state => state.rank,
      lvl: state => state.lvl,
      exp: state => state.exp,
      progress: state => state.progress,
      point: state => state.point,
      account: state => state.account,
      challengeResult: state => state.challenge_result,
      routineResult: state => state.routine_result
    }),
    ...mapState('Assets', {
      loadedAssets: state => state.assets
    }),
    routineResultDates() {
      return this.routineResult.records.map((record) => {
        return record.date
      })
    }
  },
  methods: {
    ...mapActions('Assets', ['fetchAssets', 'isAssetLoaded']),
    async load() {
      try {
        this.assetLoaded = await this.isAssetLoaded('routineTop')
        await this.fetchAssets({
          currentPage: 'routineTop',
          assets: this.assets
        })
        setTimeout(() => {
          this.assetLoaded = true
        }, 500)
      } catch (e) {
        alert('読み込みエラー')
        this.$router.push('/')
      }
    },
    handleStartButtonClick() {
      this.$router.push('/routine/player')
    }
  },
  async mounted() {
    await this.load()
  }
}
</script>

<style lang="scss" scoped>
.RoutineTopPage {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center bottom;
  background-image: url(../assets/bg_challenge.jpg);
}

.content {
  // display: flex;
  justify-content: center;
  // align-items: center;
  width: 100%;
  height: calc(100% - 80px);
  font-size: 3rem;
}

.layout {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1180px;
  height: 526px;
  border: 3px solid #000;
  background: white;
}

.introduction {
  padding: 40px;
  width: 50%;

  .title {
    margin: 0 0 20px 0;
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
  }

  .description {
    margin: 0 0 30px 0;
    text-align: center;
    font-size: 2rem;
  }

  .combo {
    margin: 0 -40px 40px;
    padding: 15px;
    text-align: center;
    font-weight: bold;
    background:lightseagreen;
    color: #fff;
    font-size: 4rem;
    line-height: 1;
  }

  .startButton {
    margin-bottom: 20px !important;
    background: red;
  }

  .total {
    margin-bottom: 30px;
    text-align: center;

    span {
      margin: 0 10px;
      color: orange;
      font-weight: bold;
      font-size: 3rem;
    }
  }
}

.calendar {
  height: 100%;
  border-left: 3px solid #000;
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1000;
}

.calendar {
  flex: 1;
}
</style>
